import { render, staticRenderFns } from "./CrearComentario.vue?vue&type=template&id=25c80994"
import script from "./CrearComentario.vue?vue&type=script&lang=js"
export * from "./CrearComentario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports